export default "__VITE_ASSET__BYrU_OK9__"